import { render, staticRenderFns } from "./pipingGasketsDetail.vue?vue&type=template&id=36ede9ff"
import script from "./pipingGasketsDetail.vue?vue&type=script&lang=js"
export * from "./pipingGasketsDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36ede9ff')) {
      api.createRecord('36ede9ff', component.options)
    } else {
      api.reload('36ede9ff', component.options)
    }
    module.hot.accept("./pipingGasketsDetail.vue?vue&type=template&id=36ede9ff", function () {
      api.rerender('36ede9ff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/psi/pfi/pipingGasketsDetail.vue"
export default component.exports